import { createClient } from '@/shared/api';
import UPDATE_HOLTER_HR_DAILY_SUMMARY_MUTATION from '@/entities/heart-rate/api/mutations/updateHolterHrDailySummary';
import type { HrsOnBeat } from '@/entities/heart-rate/api/fragments/hrsOnBeatFragment';
import type {
  UpdateHolterHrDailySummaryMutation,
  UpdateHolterHrDailySummaryMutationVariables,
} from '@/shared/api/generated/graphql';

export type MctDailySummary = {
  date: string;
  isEmpty: boolean;
  minHr: { value: number; time: string; hrsOnBeat: HrsOnBeat; userUpdated: boolean };
  maxHr: { value: number; time: string; hrsOnBeat: HrsOnBeat; userUpdated: boolean };
  avgHr: { value: number; userUpdated: boolean };
  suggestHrsOnBeat: {
    minHr: { avgHr: number; userUpdated: boolean } & HrsOnBeat;
    maxHr: { avgHr: number; userUpdated: boolean } & HrsOnBeat;
  };
};

export type UpdateHolterHrDailySummaryResult = {
  mctDailySummaries: MctDailySummary[];
};

// TODO(ts): typed as the UpdateHolterHrDailySummaryInput GraphQL input once its server-side shape is documented
/**
 * Persists edits to a holter daily heart-rate summary. Runs the mutation and returns its field without inspecting the success flag.
 *
 * @param input - Mutation input carrying the daily summary edits.
 * @returns A promise resolving to the updateHolterHrDailySummary result.
 */
const handleUpdateHolterHrDailySummary = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<
    UpdateHolterHrDailySummaryMutation,
    UpdateHolterHrDailySummaryMutationVariables
  >({
    mutation: UPDATE_HOLTER_HR_DAILY_SUMMARY_MUTATION,
    variables: {
      input,
    },
  });
  const { data } = result;
  const { updateHolterHrDailySummary } = data;
  return updateHolterHrDailySummary;
};

export default handleUpdateHolterHrDailySummary;
